import React, { useRef, useState, useEffect } from "react"

import { initializeApp } from "firebase/app"
import { getAuth, signOut } from "firebase/auth"

import { Helpers } from "@flexday/common-react"
import menuIcon from "../assets/icons/menu.svg"
import userIcon from "../assets/icons/user.svg"

const UserProfileNavItem = ({
  cartUrl,
  loginUrl,
  createAccountUrl,
  loggedOutUrl,
}) => {
  const dropdownRef = useRef(null)
  const { getFirebaseConfig } = Helpers
  const [isOpen, setIsOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const firebaseConfig = getFirebaseConfig({
    REACT_APP_FIREBASE_MESSAGE_SENDER_ID:
      process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
    REACT_APP_FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    REACT_APP_FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    REACT_APP_FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  })
  const app = initializeApp(firebaseConfig)
  const auth = getAuth(app)

  auth.onAuthStateChanged(function (user) {
    if (user) {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
  })

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev)
  }

  const handleClickAway = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClickAway)

    return () => {
      document.removeEventListener("click", handleClickAway)
    }
  }, [])

  const handleLogout = async () => {
    await signOut(auth)
    window.location.href = loggedOutUrl
  }

  return (
    <nav
      ref={dropdownRef}
      onClick={toggleDropdown}
      className={`relative w-fit h-12 border border-gray-400
       rounded-full cursor-pointer select-none`}>
      <div className="flex items-center justify-center gap-3 p-3">
        <img className="p-1" src={menuIcon} alt="" />
        <img
          alt=""
          className="w-6 h-6 rounded-full"
          src={auth?.currentUser?.photoURL || userIcon}
        />
      </div>
      {isOpen && (
        <div
          className="absolute right-0 w-56 mt-2 bg-white"
          style={{ boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)" }}>
          <div className="py-1 font-medium">
            <a href={cartUrl} className="block px-4 py-2 hover:bg-gray-100">
              Cart
            </a>
            {isLoggedIn ? (
              <>
                <a
                  href={`${process.env.REACT_APP_FLEXDAY_URL}/profile`}
                  className="block px-4 py-2 hover:bg-gray-100">
                  My Profile
                </a>
                <div
                  onClick={handleLogout}
                  className="px-4 py-2 hover:bg-gray-100">
                  Logout
                </div>
              </>
            ) : (
              <>
                <a
                  href={`${loginUrl}?redirectUrl=${window.location.href}`}
                  className="block px-4 py-2 hover:bg-gray-100">
                  Login
                </a>
                <a
                  href={`${createAccountUrl}?redirectUrl=${window.location.href}`}
                  className="block px-4 py-2 hover:bg-gray-100">
                  Create Account
                </a>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  )
}

export default UserProfileNavItem
